module.exports = __webpack_public_path__ + "img/hosteleria.2889175e.jpeg";